module.exports = __webpack_public_path__ + "img/ph.e92ed121.svg";